<template>
  <span>{{ output }}</span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StoreCashbackPrice",
  props: {
    description: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      chosenVariant: "variantPicker/chosenVariant",
      allProductVariants: "variantPicker/allProductVariants",
    }),
    variant() {
      return this.allProductVariants.find(variant => variant.id === this.chosenVariant);
    },
    output() {
      if (this.variant && this.calculatePrice(this.variant.price) > 0) {
        const priceFormatted = this.$options.filters.currency(
          this.calculatePrice(this.variant.price)
        );
        return this.description.replace(this.value, priceFormatted);
      } else {
        return this.description;
      }
    },
  },
  methods: {
    calculatePrice(price) {
      return Math.round(price * parseFloat(this.value)) / 100;
    },
  },
};
</script>
